import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../models'

import type { Collection } from './collection'
import type { State } from './state'

/**
 * Core actions for a {@link Collection}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig<
  TTypeParams extends models.TypeParams.Constraint,
>(
  /**
   * Mostly used to infer {@link TTypeParams}
   */
  collection: Collection<TTypeParams>,
) {
  return {
    /**
     * Changes the current context of the entity collection
     */
    changeContext: store.actions.standalone({
      data: store.actions.Data.asIs<{
        context: TTypeParams['context'] | undefined
      }>(),
      reducerDeprecated: (state, { context }) =>
        ({ ...state, context }) satisfies State<TTypeParams>,
    }),
  } as const satisfies store.actions.Config.Constraint<State<TTypeParams>>
}
